import React from "react";
import Header from "../../../shared/layout/Header";
import ColorInit from "../../../shared/layout/ColorInit";
import { CartProvider } from "../../cart/context/CartContext";
import Footer from "../../../shared/layout/Footer";
import BottomFooter from "../../../shared/layout/BottomFooter";
import CollectionProducts from "../components/CollectionProducts";
import { useParams } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";

// Any collection at /<type>/<slug>; everything shown comes from the collection's API data.
const CollectionPage = () => {
  const { slug } = useParams();
  return (
    <CartProvider>
      <ScrollToTop smooth color="#ef253c" />
      <ColorInit color={"bigmall"} />
      <Header />
      <div className="container container-lg">
        <CollectionProducts key={slug} slug={slug} />
      </div>
      <Footer />
      <BottomFooter />
    </CartProvider>
  );
};

export default CollectionPage;
